import { getToken, removeToken } from '@/store/local/auth'

const state = {
  isLoggedIn: !!getToken() // 初始化时根据token判断登录状态
}

const mutations = {
  SET_LOGIN_STATUS: (state, status) => {
    state.isLoggedIn = status
  },
  LOGOUT: (state) => {
    state.isLoggedIn = false
    removeToken()
  }
}

const actions = {
  // 设置登录状态
  setLoginStatus({ commit }, status) {
    commit('SET_LOGIN_STATUS', status)
  },
  
  // 处理接口响应，根据code判断登录状态
  handleApiResponse({ commit }, response) {
    if (response && response.data && response.data.code === -1) {
      // code为-1表示未登录或token过期
      commit('LOGOUT')
      return false
    } else {
      // 其他情况认为是登录状态
      commit('SET_LOGIN_STATUS', true)
      return true
    }
  },
  
  // 登出
  logout({ commit }) {
    commit('LOGOUT')
  }
}

const getters = {
  isLoggedIn: state => state.isLoggedIn
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
